module.exports = __webpack_public_path__ + "static/assets/d18087ea65c67b12e0452290cb73bb80.svg";